var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-[#333333] text-center"},[_c('span',{staticClass:"text-[#F95031]"},[_vm._v(_vm._s(_vm.fraction.numerator))]),_vm._v("/"+_vm._s(_vm.fraction.denominator)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }